export class ProofApiOriginError extends Error {
  constructor() {
    super('proof_api_origin_invalid');
  }
}

const LOOPBACK_HOSTS = new Set(['127.0.0.1', 'localhost', '::1', '[::1]']);

export function resolveProofApiUrl(
  path: string,
  configuredBase: string,
  browserOrigin: string,
): string {
  const hasControlCharacter = [...path].some((character) => {
    const code = character.charCodeAt(0);
    return code <= 31 || code === 127;
  });
  if (!path.startsWith('/api/') || path.includes('\\') || hasControlCharacter) {
    throw new ProofApiOriginError();
  }
  let origin: URL;
  let base: URL;
  try {
    origin = new URL(browserOrigin);
    base = configuredBase.trim() ? new URL(configuredBase, origin) : origin;
  } catch {
    throw new ProofApiOriginError();
  }
  if (origin.protocol !== 'https:' && !LOOPBACK_HOSTS.has(origin.hostname)) {
    throw new ProofApiOriginError();
  }
  if (base.origin !== origin.origin
    || base.username || base.password || base.search || base.hash
    || (base.pathname !== '/' && base.pathname !== '')) {
    throw new ProofApiOriginError();
  }
  const target = new URL(path, origin);
  if (target.origin !== origin.origin) throw new ProofApiOriginError();
  return target.toString();
}
